import React from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import styled from 'styled-components';

const NoDataSpan = styled.span`
  color: #757575;
  font-style: italic;
`;

interface Props extends MessageSourceProps {
  messageKey: string
}

const EmptyDataMessage = (props: Props) => {
  const {getMessage, messageKey} = props;

  return (
      <NoDataSpan>{getMessage(messageKey)}</NoDataSpan>
  );
};


export default withMessages(EmptyDataMessage);

